import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  signUpUserDetail: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSignUpUserDetail: (state, action) => {
      state.signUpUserDetail = action.payload;
    },
    deleteSignUpUserDetail: (state, action) => {
      state.signUpUserDetail = null;
    },
    deleteUser: (state, action) => {
      state.user = null;
    },
  },
});
export const {
  setUser,
  deleteUser,
  setSignUpUserDetail,
  deleteSignUpUserDetail,
} = authSlice.actions;

export default authSlice.reducer;
